import { cx } from '@emotion/css';
import { ArrowForward, ArrowForwardRounded } from '@mui/icons-material';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { FC } from 'react';

import { agencyClaimConfig } from '_features/agency/claim/agency-claim.config';

import * as S from './styles';

type StepsBarProps = {
  activeStep: number;
};

export const StepsBar: FC<StepsBarProps> = (props: StepsBarProps) => {
  const { activeStep } = props;
  const { t } = useTranslation(agencyClaimConfig.i18nNamespaces);
  const steps = [
    t('agency:claim.steps.agencyName_V2'),
    t('agency:claim.steps.agencyDetails'),
    t('agency:claim.steps.accountCreation'),
  ];

  return (
    <S.ProgressBar className="sticky border-bottom border-secondary-300 bg-neutral-50 width-100 layout-row layout-align-center-center px-4">
      {steps.map((label, index) => {
        return (
          <div
            key={label}
            className={cx({ 'hide show-gt-sm': activeStep != index + 1 }, 'layout-row layout-align-center-center')}>
            <S.StepNumber
              className={cx(
                activeStep === index + 1
                  ? 'bg-secondary-900 text-secondary-100 bold'
                  : 'bg-secondary-300 text-secondary-500',
                'text-center mr-2 small rounded-full layout-column layout-align-center-center',
              )}>
              {index + 1}
            </S.StepNumber>
            <span
              className={cx(activeStep === index + 1 ? 'medium text-secondary-900' : ' text-secondary-500', 'small')}>
              {label}
            </span>
            {index + 1 != steps.length && (
              <ArrowForwardRounded
                className={cx({ 'hide show-gt-sm': activeStep === index + 1 }, 'mx-4 text-secondary-500')}
                style={{ fontSize: 14 }}
              />
            )}
          </div>
        );
      })}
    </S.ProgressBar>
  );
};
